export const DIGITAL_PUBLIC_INFRASTUCTURE_RESET_STATE = 'DIGITAL_PUBLIC_INFRASTUCTURE_RESET_STATE';
export const DIGITAL_PUBLIC_INFRASTUCTURE_CURRENT_ITEM = 'DIGITAL_PUBLIC_INFRASTUCTURE_CURRENT_ITEM';

export const DIGITAL_PUBLIC_INFRASTUCTURE_REQUEST_LOADING = 'DIGITAL_PUBLIC_INFRASTUCTURE_REQUEST_LOADING';
export const DIGITAL_PUBLIC_INFRASTUCTURE_REQUEST_SUCCESS = 'DIGITAL_PUBLIC_INFRASTUCTURE_REQUEST_SUCCESS';
export const DIGITAL_PUBLIC_INFRASTUCTURE_REQUEST_FAILED = 'DIGITAL_PUBLIC_INFRASTUCTURE_REQUEST_FAILED';

export const DIGITAL_PUBLIC_INFRASTUCTURE_CURRENT_ACTION = 'DIGITAL_PUBLIC_INFRASTUCTURE_CURRENT_ACTION';
export const DIGITAL_PUBLIC_INFRASTUCTURE_RESET_ACTION = 'DIGITAL_PUBLIC_INFRASTUCTURE_RESET_ACTION';